import React from "react";
import PropTypes from "prop-types";

const BelongingsForm = ({ data, signatureData, currentDate }) => {
  const defaultDate = new Date().toLocaleDateString();

  // Helper to display "Yes" / "No" or fallback for boolean fields
  const displayBool = (val) =>
    val === true ? "Yes" : val === false ? "No" : "____________";

  const CheckboxOption = ({ label, checked }) => (
    <span
      style={{
        display: "inline-block",
        marginRight: "16px",
        fontFamily: "Arial",
        fontSize: "14px",
      }}
    >
      <span
        style={{
          display: "inline-block",
          width: "14px",
          height: "14px",
          border: "1px solid #000",
          marginRight: "6px",
          verticalAlign: "middle",
          position: "relative",
        }}
      >
        {checked && (
          <span
            style={{
              position: "absolute",
              top: "2px",
              left: "4px",
              width: "5px",
              height: "9px",
              border: "solid black",
              borderWidth: "0 2px 2px 0",
              transform: "rotate(45deg)",
            }}
          />
        )}
      </span>
      <span style={{ verticalAlign: "middle" }}>{label}</span>
    </span>
  );

  return (
    <div
      style={{
        fontFamily: "Arial",
        padding: "20px",
        maxWidth: "800px",
        margin: "0 auto",
        lineHeight: "1.2",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <h2
          style={{
            fontSize: "20pt",
            borderBottom: "2px solid black",
            display: "inline-block",
          }}
        >
          Belongings Placed in the Safe
        </h2>
      </div>

      <div style={{ marginBottom: "20px" }}>
        <div style={{ display: "inline-block", marginRight: "50px" }}>
          Date: {data.belongingsDate || "____________"}
          <div style={{ marginTop: "10px" }}>
            Additional items in storage?
            <span style={{ marginLeft: "30px" }}>
              <CheckboxOption label="Yes" checked={data.hasAdditionalItems} />
              <CheckboxOption label="No" checked={!data.hasAdditionalItems} />
              {data.additionalItemsDetails || "_____________"}
            </span>
          </div>
        </div>
      </div>

      {/* Identification items */}
      <div style={{ marginBottom: "10px" }}>
        Driver's license: {displayBool(data.driversLicense)} &nbsp;&nbsp;&nbsp;
        Insurance card(s): {displayBool(data.insuranceCards)}
      </div>

      <div style={{ marginBottom: "20px" }}>
        Other IDs: {displayBool(data.otherIDs)}
      </div>

      {/* Financial items */}
      <div style={{ marginBottom: "10px" }}>
        Cash amount: {data.cashAmount} &nbsp;&nbsp;&nbsp; Wallet:{" "}
        {displayBool(data.wallet)}
      </div>

      <div style={{ marginBottom: "20px" }}>
        Checks (blank): {displayBool(data.blankChecks)} &nbsp;&nbsp;&nbsp;
        Checks written: {displayBool(data.writtenChecks)}
      </div>

      <div
        style={{
          marginBottom: "20px",
          border: "1px solid black",
          padding: "12px",
          borderRadius: "4px",
        }}
      >
        <div style={{ marginBottom: "8px", fontWeight: "bold" }}>
          Credit/debit cards: {displayBool(data.creditDebitCards)}
        </div>
        
        {data.cardType && displayBool(data.creditDebitCards) === "Yes" && (
          <span style={{ marginBottom: "4px" }}>
            <span style={{ fontWeight: "500" }}>Card Type: </span>
            {data.cardType}
          </span>
        )}
        {data.cardNumber && displayBool(data.creditDebitCards) === "Yes" && (
          <span>
            <span style={{ fontWeight: "500",marginLeft: "30px" }}>Card Number: </span>
            xxxx xxxx xxxx {data.cardNumber}
          </span>
        )}
      </div>

      {/* Phones and electronic devices */}
      <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
        Phones and electronic devices
      </div>

      <table
        style={{
          width: "100%",
          maxWidth: "800px",
          margin: "0 auto",
          borderCollapse: "collapse",
          border: "1px solid #000",
        }}
      >
        <tbody>
          {[1, 2, 3].map((num) => (
            <React.Fragment key={num}>
              <tr>
                <td style={{ padding: "8px", border: "1px solid #000" }}>
                  {num}. Device: {data[`device${num}`] || "__________"}
                </td>
              </tr>
              <tr>
                <td style={{ padding: "8px", border: "1px solid #000" }}>
                  Charger included?
                  <span style={{ marginLeft: "100px" }}>
                    <CheckboxOption
                      label="Y"
                      checked={data[`device${num}Charger`] === "Y"}
                    />
                    <CheckboxOption
                      label="N"
                      checked={data[`device${num}Charger`] === "N"}
                    />
                  </span>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "8px", border: "1px solid #000" }}>
                  Condition & Details:{" "}
                  {data[`device${num}Condition`] || "__________"}
                </td>
              </tr>
            </React.Fragment>
          ))}
          <tr>
            <td style={{ padding: "8px", border: "1px solid #000" }}>
              Notes/additions: {data.notes || "__________________"}
            </td>
          </tr>
          <tr>
            <td style={{ padding: "8px", border: "1px solid #000" }}>
              Sharps: {data.sharps || "__________________"}
            </td>
          </tr>
          <tr>
            <td style={{ padding: "8px", border: "1px solid #000" }}>
              Other items: {displayBool(data.otherItems)}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Disclaimer */}
      <div style={{ margin: "20px 0", fontSize: "12pt" }}>
        <p>
          Clients are to be encouraged not to keep valuables in the unit/house
          and to send them home whenever possible...
        </p>
      </div>

      {/* Acknowledgment */}
      <div style={{ marginBottom: "20px", fontSize: "12pt" }}>
        <p>
          I have reviewed the above statement and am taking responsibility for
          any items that I keep in my possession...
        </p>
      </div>

      {/* Signature section */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "30px",
          marginBottom: "40px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ textAlign: "center", flex: 1 }}>
              <div style={{ marginBottom: "30px" }}>
                <img
                  src={signatureData || ""}
                  alt="Client Signature"
                  style={{
                    width: "200px",
                    height: "70px",
                    borderBottom: "1px solid black",
                  }}
                />
                <p>
                  <span>Client Signature:</span>
                </p>
              </div>
            </div>
            <div style={{ textAlign: "center", flex: 1 }}>
              <div
                style={{
                  marginBottom: "20px",
                  marginTop: signatureData ? "60px" : "0",
                }}
              >
                <div>{currentDate}</div>
                <div
                  style={{ borderBottom: "1px solid black", width: "100px" }}
                ></div>
                <p>Date:</p>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            border: "1px solid #000",
            padding: "10px 20px",
            minWidth: "300px",
            marginLeft: "40px",
          }}
        >
          <div style={{ marginBottom: "10px" }}>
            <strong>Date:</strong>{" "}
            {data.completionDate || "_______________________"}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <strong>Completed By:</strong>{" "}
            {data.completedBy || "________________"}
          </div>
          <div>
            <strong>Location:</strong>{" "}
            {data.location || "Legacy Healing Margate"}
          </div>
        </div>
      </div>
    </div>
  );
};

BelongingsForm.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    belongingsDate: PropTypes.string,
    hasAdditionalItems: PropTypes.bool,
    additionalItemsDetails: PropTypes.string,
    driversLicense: PropTypes.bool,
    insuranceCards: PropTypes.bool,
    otherIDs: PropTypes.bool,
    cashAmount: PropTypes.bool,
    wallet: PropTypes.bool,
    blankChecks: PropTypes.bool,
    writtenChecks: PropTypes.bool,
    creditDebitCards: PropTypes.bool,
    device1: PropTypes.string,
    device1Charger: PropTypes.string,
    device1Condition: PropTypes.string,
    device2: PropTypes.string,
    device2Charger: PropTypes.string,
    device2Condition: PropTypes.string,
    device3: PropTypes.string,
    device3Charger: PropTypes.string,
    device3Condition: PropTypes.string,
    notes: PropTypes.string,
    sharps: PropTypes.string,
    otherItems: PropTypes.bool,
    completionDate: PropTypes.string,
    completedBy: PropTypes.string,
    location: PropTypes.string,
  }).isRequired,
  signatureData: PropTypes.string,
  currentDate: PropTypes.string,
};

export default BelongingsForm;
